module.exports = __webpack_public_path__ + "img/ikinci-el-arac-garanti-sigortasi.072843fb.png";